<template>
    <div class="row">
        <div class="col-12">
            <page-header
                left-side-class="col-12 col-md-7"                
                :page="headerConfig"
                :actions="pageActionConfig"
                right-side-class="col-12 col-md-5 d-flex align-items-end mb-2"                
                />              
            <ul
                class="d-flex justify-content-between tab-list nav nav-pills mb-3 mt-4"
                role="tablist"
            >   
                <li class="col-6 text-center py-2 tab-item">
                    <a
                    class="nav-link no-margin-left mt-1 py-2 tab-link"
                    :class="{
                        active: activeTab === tabs.EVALUACIONES,
                        'link-disabled': disabled
                    }"
                    href="#evaluaciones"
                    role="tab"
                    aria-selected="true"
                    aria-controls="tab-i"
                    @click="activeTab = tabs.EVALUACIONES"
                    >Evaluaciones</a
                    >
                </li>
                <li class="col-6 text-center py-2 tab-item">
                    <a
                    class="nav-link no-margin-left mt-1 py-2 tab-link"
                    :class="{
                        active: activeTab === tabs.PEI,
                        'link-disabled': disabled
                    }"
                    href="#pei"
                    role="tab"
                    aria-selected="true"
                    aria-controls="tab-i"
                    @click="activeTab = tabs.PEI"
                    >PEI Electrónico</a
                    >
                </li>
            </ul>   
            <custom-separator class="mt-4 mb-4 custom-separator-line" text="Resultados" />
            <div v-if="activeTab === tabs.EVALUACIONES">
                <student-evaluations :student-sie-id="studentSie"/>
            </div>
            <div v-if="activeTab === tabs.PEI">
                <student-pei :student-sie-id="studentSie"/>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "PageHeader";
import CustomSeparator from "custom-separator";
import StudentEvaluations from "./components/StudentEvaluations"
import StudentPei from "./components/StudentPei"

const TABS = {
  EVALUACIONES: 0,
  PEI: 1
};

export default {
    name: 'StudentDetail',
    components: {
        PageHeader,
        CustomSeparator,
        StudentEvaluations,
        StudentPei
    },
    data: () => ({
        activeTab: null,
        disabled: false,
        tabs: TABS,
    }),    
    computed:{
        pageActionConfig() {
            return [
                {
                    text: 'Regresar',
                    icon: 'fas fa-arrow-circle-left',
                    variant: 'outline-success',
                    click: () => this.back(),
                },
            ];
        },
        headerConfig() {
            return {
                title: "Red de vigilancia de autismo",            
                icon: "fas fa-user-circle",
                routes: [
                "Inicio",
                "Estudiante",
                "Red de vigilancia de autismo"          
                ]
            };
        },
        studentSie(){          
            return this.$route.params.studentSie.toString()
        }
    },
    mounted(){
        this.activeTab = TABS.EVALUACIONES;
    },
    methods: {
        back() {
            this.$router.push({ name: 'autismsurveillancenetwork'});
        },
    }
}
</script>

<style scoped>
.link-disabled {
  pointer-events: none;
}

.tab-link {
  height: 40px !important;
  background-color: #fff;
}

.tab-link:hover {
    background-color: #fff;
}

.tab-link .active:hover{
    background-color: #ff7058;
}

</style>

<style>
/* Not scoped by design */
.nav-text {
  font-weight: bold !important;
}

.tab-item {
  background: #f2f2f2 0% 0% no-repeat padding-box;
}
</style>
